
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'service-header',
  templateUrl: '../../templates/partials/header-service.html'
})
export class HeaderServiceComponent{

    @Output() showModal = new EventEmitter();
    @Input() headerData;

    constructor(){}

     public showModalCancel(){
        this.showModal.emit({action:"open",data:this.headerData});
    }
    
    public setServiceClass(){
        //console.log(this.headerData);
        if(this.headerData["canceled"] == 1) return "red";
        if(this.headerData["done"] == 1) return "done";
        if((this.headerData.isSame && this.headerData.now >= this.headerData.time_ini && this.headerData.now < this.headerData.time_end) && this.headerData.done == 0) return "course";
        else return "";
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/header-service.component.ts